import React, { useState, useEffect } from 'react';
import api from './../../utils/api';
import { Button } from 'react-bootstrap';
import { numberFormat } from './../../utils/functions';
import moment from "moment";
import 'moment/locale/th'
import _ from "lodash";
import "react-datepicker/dist/react-datepicker.css";
import Select from "react-select";

export default function BookingFlexibleImageOverview({ code }) {
  const [currentMonth, setCurrentMonth] = useState(new Date())
  const [data, setData] = useState({})
  const [hotel, setHotel] = useState({});

  const [roomFlexibleType, setRoomFlexibleType] = useState([]);
  const [selectedRoomFlexibleType, setSelectedRoomFlexibleType] = useState(null);

  const { monthAndYearDisplay, monthAndYear, dayOfMonth, rooms, bookingItems, } = data;

  const fetchHotel = (code) => {
    api.request(`hotels/findwithcode/${code}`, (data) => {
      setHotel(data || {})
      if (data) {
        fetchRoomFlexibleType(data?.id);
        setSelectedRoomFlexibleType(null);
      }
    }, {});
  };

  const fetchData = () => {
    if (!selectedRoomFlexibleType) return;

    api.request('bookings/get-flex-booking-overview-data', (data) => {
      if (data?.is_success) {
        setData(data);
      } else {
        setData({});
      }
    }, {
      date: moment(currentMonth).format('YYYY-MM-DD'),
      code: code,
      type_id: selectedRoomFlexibleType?.id
    })
  }

  const fetchRoomFlexibleType = (hotel_id) => {
    api.request('room-flexibles/all', (data) => {
      setRoomFlexibleType((data || []).map(item => ({
        ...item,
        value: item.id,
        label: item.name_th
      })));
    }, {
      enabled: true,
      hotel_id: hotel_id
    });
  }

  useEffect(() => {
    if (!currentMonth || !selectedRoomFlexibleType) {
      return;
    }
    fetchData()
  }, [currentMonth, selectedRoomFlexibleType])

  useEffect(() => {
    if (!code) {
      return;
    }
    fetchHotel(code);
  }, [code])

  const sumBookingNetTotal = (room_id) => {
    // const roomBookings = bookingItems.filter(item => item.room_id === room_id && !item.is_close_zone) || []
    // return _.sum(roomBookings.map(item => Number(item.net_total) || 0));
    return 0;
  }

  const sumBookingPaidAmount = (room_id) => {
    // const roomBookings = bookingItems.filter(item => item.room_id === room_id && !item.is_close_zone) || []
    // return _.sum(roomBookings.map(item => Number(item.paid_amount) || 0));
    return 0;
  }

  const sumBookingBalanceAmount = (room_id) => {
    // const roomBookings = bookingItems.filter(item => item.room_id === room_id && !item.is_close_zone) || []
    // return _.sum(roomBookings.map(item => {
    //   return Number(item.net_total || 0) - Number(item.paid_amount || 0);
    // }));
    return 0;
  }

  const sumBookingAndBlockdaysCount = (room_id) => {
    // const roomBookings = bookingItems.filter(item => item.room_id === room_id) || []

    // const bookingDays = roomBookings.reduce((acc, item) => {
    //   const startDate = moment(item.start_date);
    //   const endDate = moment(item.end_date);
    //   const days = [];
    //   for (let m = startDate; m.isSameOrBefore(endDate); m.add(1, 'days')) {
    //     if (moment(m).isSame(currentMonth, 'month')) {
    //       days.push(m.format("YYYY-MM-DD"));
    //     }
    //   }
    //   return acc.concat(days);
    // }, []);

    // const roomBlockDaysLength = roomBlockDays.filter(item => item.room_id === room_id && !bookingDays.includes(moment(item.date).format('YYYY-MM-DD')))?.length || 0;
    // return bookingDays.length + roomBlockDaysLength;

    return 0;
  }

  return (
    <>
      <div className="text-center p-2 booking-image-overview-page" style={{ maxWidth: '800px', margin: '0 auto' }}>
        <h3>Booking Overview</h3>
        <h3>{hotel.name_th}</h3>
        <div className="d-flex mb-3 align-items-center">
          <div className="overview-state-info" style={{ backgroundColor: '#90ee9061' }}></div><span className="text-black ms-2">Booked</span>
          <div className="text-black text-end" style={{ flex: 1 }}>
            <div>Exported by ONCE IN MEMORY</div>
            <div>{`Latest update: ${moment().locale('th').format('DD/MM/YYYY HH:mm ')}`}</div>
          </div>
        </div>

        <div className="d-flex align-items-center mb-2">
          <Button
            variant="outline-success"
            className="btn btn-sm "
            onClick={() => setCurrentMonth(prev => moment(prev).subtract(1, 'months').toDate())}
          >
            &lt; Prev
          </Button>
          <h4 className="mb-0 px-3">{monthAndYearDisplay}</h4>
          <Button
            variant="outline-success"
            className="btn btn-sm "
            onClick={() => setCurrentMonth(prev => moment(prev).add(1, 'months').toDate())}
          >
            Next &gt;
          </Button>
          <div style={{ flex: 1 }} className="text-end d-none d-md-block ps-5">
            <Select
              options={roomFlexibleType}
              onChange={(option) => {
                setSelectedRoomFlexibleType(option)
              }}
              className={`flex-fill mt-2`}
              placeholder="เลือกประเภทห้องพัก"
              value={selectedRoomFlexibleType}
              classNamePrefix="react-select-custom"
              id={`camp_type_select`}
              required
            />
          </div>
        </div>
        <div className="text-start d-block d-md-none">
          <Select
            options={roomFlexibleType}
            onChange={(option) => {
              setSelectedRoomFlexibleType(option)
            }}
            className={`flex-fill mt-2`}
            placeholder="เลือกประเภทห้องพัก"
            value={selectedRoomFlexibleType}
            classNamePrefix="react-select-custom"
            id={`camp_type_select`}
            required
          />
        </div>
        {!data?.is_success && <div style={{ minHeight: 500 }}>
          <h4 className="text-danger py-5">กรุณาเลือกประเภทห้องพัก</h4>
        </div>}
        {!!data?.is_success && <div className="booking-image-overview-table" style={{ overflowX: 'auto' }}>
          <table className="table table-bordered" style={{ width: '100%', borderCollapse: 'collapse', backgroundColor: '#d3d3d37d' }}>
            <thead>
              <tr>
                <th style={{ width: '150px' }}>DAY</th>
                {Array.from({ length: dayOfMonth }, (_, i) => i + 1).map((day, index) => {
                  const currentdate = moment(`${monthAndYear}-${day < 10 ? `0${day}` : day}`).format("YYYY-MM-DD")
                  const dayOfWeek = moment(currentdate).day()
                  const dayName = moment(currentdate).locale('en').format('ddd')

                  return <th key={index} > {dayName}</th>
                })}
              </tr>
              <tr>
                <th style={{ width: '150px' }}>DATE</th>
                {Array.from({ length: dayOfMonth }, (_, i) => i + 1).map((day, index) => {
                  const currentdate = moment(`${monthAndYear}-${day < 10 ? `0${day}` : day}`).format("YYYY-MM-DD")
                  const dayOfWeek = moment(currentdate).day()
                  const dayName = moment(currentdate).locale('en').format('ddd')

                  return <th key={index}> {day}</th>
                })}
              </tr>
              <tr>
                <th style={{ width: '150px' }}>ROOM</th>
                {Array.from({ length: dayOfMonth }, (_, i) => i + 1).map((day, index) => {
                  const sumBookingOnThisDay = bookingItems.filter(item => item.booking?.start_date <= moment(`${monthAndYear}-${day < 10 ? `0${day}` : day}`).format("YYYY-MM-DD") && item.booking?.end_date >= moment(`${monthAndYear}-${day < 10 ? `0${day}` : day}`).format("YYYY-MM-DD")).length || 0
                  return <th key={index} style={{ color: 'green' }}> {sumBookingOnThisDay}</th>
                })}
              </tr>
            </thead>
            <tbody>
              {rooms.map((room, index) => {
                return (
                  <tr key={index}>
                    <td className="flex-td">{room.name_th}</td>
                    {Array.from({ length: dayOfMonth }, (_, i) => i + 1).map((day, index) => {
                      const currentdate = moment(`${monthAndYear}-${day < 10 ? `0${day}` : day}`).format("YYYY-MM-DD")
                      const dayOfWeek = moment(currentdate).day()
                      const dayName = moment(currentdate).locale('en').format('ddd')

                      const bookingItem = bookingItems.find((b) => b.roomItem?.id === room.id && b.booking?.start_date <= currentdate && b.booking?.end_date >= currentdate)

                      const bookingBgCls = !!bookingItem ? (Number(bookingItem.booking?.day_qty) > 1 ? 'booking-overview-multiple' : 'booking-overview-normal') : '';

                      const infoStr = bookingItem ? `${numberFormat(bookingItem.booking?.net_total, true)}` : '';
                      return <td className={`${!!bookingItem ? 'text-end' : 'text-center'} ${bookingBgCls}`} key={index}>
                        <div>
                          {(Number(bookingItem?.booking?.day_qty) > 1) && <span>{bookingItem?.booking?.day_qty}<i className="fal fa-calendar-alt mx-1"></i></span>}
                          <span>{infoStr}</span>
                        </div>
                        {!!bookingItem && <div className="customer-info">
                          <small className={`d-block text-muted`}>{bookingItem?.booking?.contact_name}</small>
                          <small className={`d-block text-muted`}>{bookingItem?.booking?.contact_tel_1}</small>
                        </div>}
                      </td>
                    })}
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>}
      </div>
    </>
  );
}
